import { useState } from 'react';
import FreeTrialTutorialView from './FreeTrialTutorialView';
import FreeTrialLessonView from './FreeTrialLessonView';
import { FreeTrialContextItem } from '../../constants/types/free-trial/type';

interface FreeTrialLessonStepProps {
  freeTrialContext: FreeTrialContextItem;
  onComplete: () => void;
}

type ViewType = 'TUTORIAL' | 'LESSON';

const FreeTrialLessonStep = ({
  freeTrialContext,
  onComplete,
}: FreeTrialLessonStepProps) => {
  const [view, setView] = useState<ViewType>('TUTORIAL');

  const handleShowTutorial = () => {
    setView('TUTORIAL');
  };

  const handleShowLesson = () => {
    setView('LESSON');
  };

  if (view === 'TUTORIAL') {
    return <FreeTrialTutorialView onShowLesson={handleShowLesson} />;
  }

  return (
    <FreeTrialLessonView
      freeTrialContext={freeTrialContext}
      onShowTutorial={handleShowTutorial}
      onComplete={onComplete}
    />
  );
};

export default FreeTrialLessonStep;
